// Motion tokeny — zrcadlí motion hodnoty v globals.css (@theme + .reveal).

export const duration = {
  fast: 160,
  base: 260,
  slow: 480,
  reveal: 620,
} as const;

export const ease = {
  standard: [0.22, 1, 0.36, 1] as const,
  inOut: [0.65, 0, 0.35, 1] as const,
} as const;

export const stagger = 70;

export const revealThreshold = 0.18;
